import * as React from "react";
import { useState, useEffect } from "react";
import ProgressiveImage from "react-progressive-image";
import { CSSTransition } from "react-transition-group";
import defaultImagem from "common/assets/images/thumb-default.png";

import { StyleSheet, css } from "aphrodite";
import * as firebase from "firebase";

type IProps = {
  imageUrl: string;
  imageName: string;
};

const styles = StyleSheet.create({
  imgHigh: {
    top: "-100%",
    left: 0,
    right: 0,
    bottom: "-100%",
    margin: "auto",
    width: "100%",
  },
  imgLong: {
    left: "-100%",
    top: 0,
    bottom: 0,
    right: "-100%",
    margin: "auto",
    height: "100%",
  },
  container: {
    height: "125px",
    width: "100%",
    overflow: "hidden",
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
});

function CardGridImage(props: IProps) {
  const { imageName, imageUrl } = props;
  const [cardImageURL, setCardImageURL] = useState(defaultImagem);
  const setClassName = (node: any) => {
    if (node) {
      if (node.clientWidth / node.clientHeight > 1.84)
        node.className = css(styles.imgLong);
      else node.className = css(styles.imgHigh);
    }
  };
  // PRUBK-819 - Corrigindo erro de looping do render
  useEffect(() => {
    // PRUBK-808: Corrigir o erro de não exibir imagem vinculada ao projeto e fica em branco.
    // Criar uma referencia no storage apontando para a imagem na pasta images
    if (imageName) {
      var imageRef = firebase.storage().ref().child(`images/${imageName}`);
      if (imageRef.fullPath !== "") {
        // Verifica se o arquivo estiver no storage com a metadata
        imageRef
          .getMetadata()
          .then((metadata) => {
            setCardImageURL(imageUrl);
          })
          .catch((error) => {});
      }
    }
    // com o array em branco ele executa o código só uma vez, caso tenha um valor ele só executa se houver uma mudança no mesmo
  }, [imageUrl]);
  // let imageURL = imageUrl ? imageUrl : defaultImagem;
  return (
    <div className={css(styles.container)} style={{ position: "relative" }}>
      <ProgressiveImage src={cardImageURL} placeholder="tiny-image.jpg">
        {(src, loading) => (
          <CSSTransition
            in={!loading}
            enter={true}
            exit={true}
            timeout={300}
            classNames={{
              enter: css(styles.transitionEnter),
              enterActive: css(styles.transitionEnterActive),
              exit: css(styles.transitionLeave),
              exitActive: css(styles.transitionLeaveActive),
            }}
            unmountOnExit
          >
            <img
              src={src}
              ref={setClassName}
              style={{ position: "absolute" }}
            />
          </CSSTransition>
        )}
      </ProgressiveImage>
    </div>
  );
}

export default CardGridImage;



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/CardGridImage.tsx